"use strict"

import { getCookie } from "../utils/cookie-handler";

export function init() {
    const SELECTOR = '.js-cart-status';
    const INNER = '.cart-number'
    const element = document.querySelector(SELECTOR);

    if (element === null) {
        return false;
    }

    let cartCount = getCookie('_bo_basket_count');

    if (cartCount) {
        element.querySelector(INNER).innerText = cartCount;
        element.querySelector(INNER).classList.add('toggle');
    } else {
        element.querySelector(INNER).classList.remove('toggle');
    }
}

export default { init }
